export default {
  // 搜索選擇器
  transactionDirection: "交易方向",
  virtualCurrency: "虛擬幣幣種",
  fiatCurrency: "法幣幣種",
  pleaseSelect: "請選擇",
  totalAmount: "總數量",
  transactionAmount: "交易數量",
  minAmount: "最小金額",
  maxAmount: "最大金額",
  maxAmountWarning: "最大數量需≥最小數量",

  // 日期選擇器
  dateRangeSeparator: "→",
  startDatePlaceholder: "開始日期",
  endDatePlaceholder: "結束日期",

  // 按鈕
  reset: "重置",
  query: "查詢",

  // 數據統計
  totalData: "共計{count}條數據",

  // 加載
  loading: "拼命加載中",

  // 表格列
  direction: "交易方向",
  currency: "幣種",
  quantity: "交易數量",
  unitPrice: "單價",
  fiatCurrencyColumn: "法幣",
  totalMoney: "總金額",
  transactionTime: "交易時間",

  // 交易方向
  buy: "買入",
  sell: "賣出",
  unknown: "未知",

  // 空狀態
  noOtcData: "當前調證文件中未解析到OTC交易數據",

  // 下載
  downloadDetails: "下載數據明細",
  downloadFileName: "數據明細",
};
